import React, { useState } from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import WidgetDescription from '../WidgetDescription';
import { Card, CardBody } from 'react-bootstrap';

export default function TribalCollege({ institutionData, className }) {
    const is_tribal_college = institutionData.post_meta.tribal.value == "1";
    if (!is_tribal_college) return null;
    
    const cardClass = ' tribal-college ' + (className || '');

    return (
        <Card className={cardClass}>
            <CardBody>
                <WidgetTitle>Tribal College or University</WidgetTitle>
                <p style={{ fontSize: "16px" }}>This institution has been designated as a Tribal College or University by the U.S. Department of Education.</p>                
            </CardBody>
        </Card>
    );
}